import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export interface IDistributionEfficiencyFilter {
  date?: Dayjs[];
  comparisonDate?: Dayjs[];
  warehouseId?: number;
}

type TState = {
  filters: IDistributionEfficiencyFilter;
};

type TActions = {
  setFilters: (value: IDistributionEfficiencyFilter | undefined) => void;
};

export const useDistributionEfficiencyFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE },
    setFilters: (filters: IDistributionEfficiencyFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'distribution-efficiency-filters-store',
);
